import { useTranslation } from "react-i18next";
import { DatePickerControl, FileInputControl, InputControl } from "@/controls";
import { Column, Row, todayIso } from "@/ui-kit";

export const HudForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <InputControl label={t("label.hud_id_number")} name="hudIdNumber" />

      <Row gap="md" alignmentVertical="top">
        <Column fullWidth>
          <DatePickerControl
            label={t("label.issuance_date")}
            name="hudIdIssuanceDate"
            maxDate={todayIso()}
          />
        </Column>
        <Column fullWidth>
          <DatePickerControl
            label={t("label.expiry_date")}
            name="hudIdExpiryDate"
            minDate={todayIso()}
          />
        </Column>
      </Row>

      <FileInputControl
        label={t("label.hud_front_image")}
        name="hudFrontPicture"
      />

      <FileInputControl
        label={t("label.hud_back_image")}
        name="hudBackPicture"
      />
    </>
  );
};
